export function normalizeColumnName(name: string | number): string {
    return String(name).toLowerCase().trim();
}
